import { render, staticRenderFns } from "./EmployeePayments.vue?vue&type=template&id=c6853008&scoped=true"
import script from "./EmployeePayments.vue?vue&type=script&lang=js"
export * from "./EmployeePayments.vue?vue&type=script&lang=js"
import style0 from "./EmployeePayments.vue?vue&type=style&index=0&id=c6853008&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6853008",
  null
  
)

export default component.exports